import React from 'react';
import SoundButton from './SoundButton';
import { View, Text, FlatList, Image, TouchableOpacity } from 'react-native';
import SoundDivider from './SoundDivider'
import heroes from './assets/heroes.json';
import specials from './assets/specials.json';
import {AVHeroCards, newHeroSpecials} from './HelperFunctions'

const SpecialsFlatList = (props) => {

  // Need a scroll to top when new card is clicked.

  let specials = []

  if (props.card.sounds) {
    specials = props.card.sounds.filter(sound => sound.name == 'Special')
  }

  return (
    <>
    {specials.length > 0
      ?
      <>
        <View style={{flexDirection: 'row', alignSelf: 'flex-start', width: '100%', paddingBottom: 8}}>
          <Text style={{alignSelf: 'flex-start', paddingRight: 8, fontWeight: 'bold', width: 80}}>Special</Text>
            <FlatList
              horizontal='true'
              data={specials}
              renderItem={({ item, index }) => (
                  <View style={{alignItems: 'center', justifyContent: 'flex-start'}}>
                    <TouchableOpacity onPress={() => {item.special_id.includes("HERO_00") ? {} : props.openNewCard(item.special_id)}} style={{marginBottom: -24}}>
                      <SpecialImage cardID={item.special_id}/>
                    </TouchableOpacity>
                    <SoundButton title={item.action} sound={item.audio} />
                  </View>
              ) }
            />
        </View>
        <SoundDivider/>
      </>
      : <></>
    }
    </>
  )
}

const SpecialImage = (props) => {
  const cardID = props.cardID
  const isHero = heroes.map(a => a.id).includes(cardID) || cardID.includes("HERO_00")

  const isAVHeroCard = AVHeroCards.includes(cardID)
  const imgSrc = ((isHero || AVHeroCards.includes(cardID) ||
    ['TB_BaconShop_HERO_11','BG20_HERO_201','TB_BaconShop_HERO_27','TB_BaconShop_HERO_78','EX1_323h'].includes(cardID)) ?
    'https://hearthstonesounds.s3.amazonaws.com/hero_images/' :
    'https://art.hearthstonejson.com/v1/render/latest/enUS/256x/')
    + cardID + '.png'

  return (
    <View style={{padding: 10}}>
    {isHero 
      ? <Image source={{uri: imgSrc}} style={{width: 160, height: 160, resizeMode:'stretch', marginBottom: 17, marginRight: -16, marginLeft: -16}}/>
      : isAVHeroCard 
        ? <Image source={{uri: imgSrc}} style={{width: 120, height: 165.76, resizeMode:'contain', marginLeft: 4, marginRight: 4, marginBottom: 21.24, marginTop: -10}}/>
        : <Image source={{uri: imgSrc}} style={{width: 128, height: 194, marginTop: -17, resizeMode:'stretch'}}/>
    }
    </View>
  )
}

export default SpecialsFlatList